/**
 * * Запрос на получение информации об очереди задач
 */
export class ProjectQueueTaskGetRequestModel {
  /**
   * * Айди очереди задач
   */
  QueueTaskId!: string;
  constructor(obj?: Partial<ProjectQueueTaskGetRequestModel>) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
